import { ideaCreateConstans, ideaConstants } from '../constants';
import update from 'react-addons-update';
import fileSize from 'filesize';

const initialState = {
  name: '',
  description: '',
  methodology: {},
  businessUnitLocal: [],
  selectedBusiness: [],
  challenge: {},
  images: [],
  video: {},
  files: [],
  links: [],
  canvas: [
    {
      key: 'Q1',
      answer: '',
    },
    {
      key: 'Q2',
      answer: '',
    },
    {
      key: 'Q3',
      answer: '',
    },
    {
      key: 'Q4',
      answer: '',
    },
    {
      key: 'Q5',
      answer: '',
    },
    {
      key: 'Q6',
      answer: '',
    },
    {
      key: 'Q7',
      answer: '',
    },
    {
      key: 'Q8',
      answer: '',
    },
    {
      key: 'Q9',
      answer: '',
    },
  ],
  canvasValueProposition: [
    {
      key: 'Q1',
      answer: '',
    },
    {
      key: 'Q2',
      answer: '',
    },
    {
      key: 'Q3',
      answer: '',
    },
    {
      key: 'Q4',
      answer: '',
    },
    {
      key: 'Q5',
      answer: '',
    },
    {
      key: 'Q6',
      answer: '',
    },
    {
      key: 'Q7',
      answer: '',
    },
    {
      key: 'Q8',
      answer: '',
    },
    {
      key: 'Q9',
      answer: '',
    },
  ],
  contributors: [],
  locals: [],
  ideaCreateChallenge: false,
  loading: false,
};

export function ideaCreate(state = initialState, action) {
  switch (action.type) {
    case ideaCreateConstans.SET_TITLE_DESCRIPTION:
      return update(state, {
        name: { $set: action.payload.name },
        description: { $set: action.payload.description },
      });

    case ideaCreateConstans.SET_METHODOLOGY:
      const methodology = action.payload.methodologies.find(
        (methodology) => methodology.code === action.payload.code
      );

      return update(state, {
        methodology: { $set: methodology },
      });

    case ideaCreateConstans.SET_BUSINESS_UNIT_LOCAL:
      return update(state, {
        businessUnitLocal: { $push: [action.payload.businessUnitLocals] },
      });

    case ideaCreateConstans.REMOVE_BUSINESS_UNIT_LOCAL:
      const newState = state.businessUnitLocal.filter(
        (BUL) => BUL._id !== action.payload.businessUnitLocals._id
      );

      return update(state, {
        businessUnitLocal: { $set: newState },
      });

    case ideaCreateConstans.SET_CHALLENGE:
      return update(state, {
        challenge: { $set: action.payload.challenge },
      });

    case ideaCreateConstans.SET_IMAGES:
      return update(state, {
        images: { $push: action.payload.images },
      });

    case ideaCreateConstans.REMOVE_IMAGE:
      const images = state.images.filter(
        (image) => image.id !== action.payload.id
      );

      return update(state, {
        images: { $set: images },
      });

    case ideaCreateConstans.SET_VIDEO:
      return update(state, {
        video: { $set: action.payload.video },
      });

    case ideaCreateConstans.REMOVE_VIDEO:
      return update(state, {
        video: { $set: {} },
      });

    case ideaCreateConstans.SET_FILES:
      return update(state, {
        files: { $push: action.payload.files },
      });

    case ideaCreateConstans.REMOVE_FILE:
      const files = state.files.filter((file) => file.id !== action.payload.id);

      return update(state, {
        files: { $set: files },
      });

    case ideaCreateConstans.SET_LINKS:
      return update(state, {
        links: { $push: [action.payload.link] },
      });

    case ideaCreateConstans.REMOVE_LINK:
      const links = state.links.filter((link) => link !== action.payload.link);

      return update(state, {
        links: { $set: links },
      });

    case ideaCreateConstans.SET_CONTRIBUTORS:
      return update(state, {
        contributors: { $set: action.payload.contributorsIds },
      });

    case ideaCreateConstans.SET_IDEA_LOCALS:
      return {
        ...state,
        locals: action.payload
      }

    case ideaCreateConstans.SET_LOCALS_CHECKED:
      const newLocals = state.locals.map((local) => {
        if (local._id === action.payload._id) {
          local.checked = true;
          return local;
        }

        return local;
      });
      return update(state, {
        locals: { $set: newLocals },
      });

    case ideaCreateConstans.SET_LOCALS_UNCHECKED: {
      const newLocals = state.locals.map((local) => {
        if (local._id === action.payload._id) {
          delete local.checked;
          return local;
        }

        return local;
      });

      return update(state, {
        locals: { $set: newLocals },
      });
    }

    case ideaCreateConstans.GET_IDEA_USER_DRAFT_SUCCESS: {
      let images = [];
      let videos = [];
      let files = [];

      const locals = state.locals.map((local) => {
        action.payload.idea.businessUnitLocal.forEach((BUL) => {
          if (BUL._id === local._id) local.checked = true;
        });
        return local;
      });

      if (action.payload.idea?.attachments?.length > 0) {
        images = action.payload.idea.attachments.filter(
          (attachment) => attachment.mimeType.container === 'images'
        );

        images = images.map((image) => ({
          type: image.mimeType.mimeType,
          name: image.fileName,
          readableSize: fileSize(image.size),
          id: image._id,
          url: image.url,
        }));

        videos = action.payload.idea.attachments.filter(
          (attachment) => attachment.mimeType.container === 'videos'
        );

        videos = videos.map((video) => ({
          type: video.mimeType.mimeType,
          name: video.fileName,
          readableSize: fileSize(video.size),
          id: video._id,
          url: video.url,
        }));

        files = action.payload.idea.attachments.filter(
          (attachment) => attachment.mimeType.container === 'dynamic-files'
        );

        files = files.map((file) => ({
          type: file.mimeType.mimeType,
          name: file.fileName,
          readableSize: fileSize(file.size),
          id: file._id,
          url: file.url,
        }));
      }

      return update(state, {
        name: { $set: action.payload.idea.name },
        description: { $set: action.payload.idea.description },
        businessUnitLocal: { $set: action.payload.idea.businessUnitLocal },
        challenge: { $set: action.payload.idea.challenge },
        contributors: { $set: action.payload.idea.contributors },
        canvas: { $set: action.payload.idea.canvas },
        canvasValueProposition: { $set: action.payload.idea.canvasValueProposition },
        locals: { $set: locals },
        _id: { $set: action.payload.idea._id },
        images: { $set: images },
        video: { $set: videos[0] },
        files: { $set: files },
        links: { $set: action.payload.idea.links },
      });
    }

    case ideaConstants.GET_IDEA_USER_DETAILS_FAILURE:
      return state;

    case ideaCreateConstans.SET_CANVAS: {
      const canvas = state.canvas.map((c) => {
        return {
          key: c.key,
          answer: action.payload.canvas[c.key],
        };
      });

      return update(state, {
        canvas: { $set: canvas },
      });
    }
    case ideaCreateConstans.SET_VALUE_CANVAS: {
      const canvasValueProposition = state.canvasValueProposition.map((c) => {
        return {
          key: c.key,
          answer: action.payload.canvasValueProposition[c.key],
        };
      });

      return update(state, {
        canvasValueProposition: { $set: canvasValueProposition },
      });
    }

    case ideaCreateConstans.CLEAR_CREATE_IDEA: {
      return initialState;
    }

    case ideaCreateConstans.CLEAR: {
      const newLocals = state.locals.map((local) => {
        delete local.checked;
        return local;
      });
      const canvas = state.canvas.map((c) => ({ key: c.key, answer: '' }));
      const canvasValueProposition = state.canvasValueProposition.map((c) => ({ key: c.key, answer: '' }));

      if (state._id) {
        delete state._id;
      }

      return update(state, {
        name: { $set: '' },
        description: { $set: '' },
        businessUnitLocal: { $set: [] },
        challenge: { $set: {} },
        images: { $set: [] },
        video: { $set: {} },
        files: { $set: [] },
        links: { $set: [] },
        contributors: { $set: [] },
        locals: { $set: newLocals },
        canvas: { $set: canvas },
        canvasValueProposition: { $set: canvasValueProposition },
        ideaCreateChallenge: { $set: false },
      });
    }

    case ideaCreateConstans.SET_IDEA_CREATE_CHALLENGE:
      return update(state, {
        ideaCreateChallenge: { $set: true },
      });

    case ideaCreateConstans.SET_SELECTED_BUSINESS: {
      return {
        ...state,
        selectedBusiness: action.payload
      }
    }

    case ideaCreateConstans.CLEAR_SELECTED_BUSIINESS: {
      return {
        ...state,
        selectedBusiness: []
      }
    }

    case ideaCreateConstans.POST_IDEA_IMAGINE_REQUEST:
      return update(state, {
        loading: { $set: true }
      });

    case ideaCreateConstans.POST_IDEA_IMAGINE_SUCCESS: 
      return update(state, {
        loading: { $set: false }
      });

    case ideaCreateConstans.POST_IDEA_IMAGINE_FAILURE:
      return update(state, {
        loading: { $set: false }
      });

    default:
      return state;
  }
}
